import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
const suggestionsRowCss = "sruewb7";
const suggestionsRowGridCss = "sa7mmj";
const suggestionsRowStackedCss = "sy4y47";

/**
 * ChatSuggestions component displays a list of clickable suggestion chips for chat interactions.
 *
 * This component renders a horizontal row of suggestion buttons that users can click
 * to quickly select predefined responses or actions in a chat interface.
 *
 * @param {Object} props - Component props
 * @param {Array<Object>} props.chatSuggestions - Array of suggestion objects to display
 * @param {string} props.chatSuggestions[].id - Unique identifier for the suggestion
 * @param {string} props.chatSuggestions[].text - Display text for the suggestion
 * @param {Function} props.onSuggestionClick - Callback function called when a suggestion is clicked
 * @param {Object} props.onSuggestionClick.suggestion - The clicked suggestion object
 * @param {boolean} [props.embedded=false] - Right-rail layout: stacked cards with rail chip styling
 *
 * @returns {JSX.Element} A container with clickable suggestion chips
 *
 * @example
 * ```jsx
 * const suggestions = [
 *   { id: '1', text: 'Hello' },
 *   { id: '2', text: 'How can I help?' }
 * ];
 *
 * <ChatSuggestions
 *   chatSuggestions={suggestions}
 *   onSuggestionClick={(suggestion) => console.log(suggestion.text)}
 * />
 * ```
 */
export const ChatSuggestions = ({
  chatSuggestions,
  onSuggestionClick,
  embedded = false
}) => <div className={classNames(suggestionsRowCss, embedded ? suggestionsRowStackedCss : suggestionsRowGridCss)} data-testid="chat-suggestions-row" data-embedded={String(embedded)}>
    {chatSuggestions.map(suggestion => <Button key={suggestion.id} appearance="ai" size="medium" data-variant={embedded ? 'embedded' : 'default'} onClick={() => onSuggestionClick(suggestion.text)}>
        {suggestion.text}
      </Button>)}
  </div>;

require("./ChatSuggestions.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ChatSuggestions.js");